import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/welcome',
    name: 'welcome',
    component: () => import('../views/Welcome/welcome.vue')
  },
  {
    path: '/',
    name: 'welcomeCopy',
    component: () => import('../views/Welcome/WelcomCopy.vue')
  },
  {
    path: '/home',
    name: 'home',
    component: () => import('../views/Home/home.vue')
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('../views/Login/login.vue')
  },
  {
    path: '/agreement',
    name: 'agreement',
    component: () => import('../views/Agreement/index.vue')
  },
  {
    path: '/mine',
    name: 'mine',
    redirect:'/mine/intelligent',
    component: () => import('../views/Mine/mine.vue'),
    children: [
      {
        path: '/mine/shortVideo',
        name: 'shortVideo',
        component: () => import('../views/Mine/shortVideo.vue')
      },
      {
        path: '/mine/draft',
        name: 'draft',
        component: () => import('../views/Mine/draft.vue')
      },
      {
        path: '/mine/source',
        name: 'source',
        component: () => import('../views/Mine/source.vue')
      },
      {
        path: '/mine/release',
        name: 'release',
        component: () => import('../views/Mine/release.vue')
      },
      {
        path: '/mine/qanswer',
        name: 'qanswer',
        component: () => import('../views/Mine/qanswer.vue')
      },
      {
        path: '/mine/intelligent',
        name: 'intelligent',
        component: () => import('../views/Mine/intelligentHuman.vue')
      },
    ]
  },
  // 首页2.0
  {
    path: '/index',
    name: 'index',
    redirect:'/intelligent',
    component: () => import('../views/Index/index.vue'),
    children:[
      {
        path: '/intelligent',
        name: 'intelligent',
        component: () => import('../views/Intelligent/index.vue')
      },
      {
        path: '/speech',
        name: 'speech',
        component: () => import('../views/Speech/index.vue')
      },
      {
        path: '/twin',
        name: 'twin',
        component: () => import('../views/Twin/index.vue')
      },
      {
        path: '/person',
        name: 'person',
        component: () => import('../views/Person/index.vue')
      },
      {
        path: '/humanCustom',
        name: 'humanCustom',
        component: () => import('../views/Intelligent/humanCustom.vue')
      },
      {
        path: '/audioCustom',
        name: 'audioCustom',
        component: () => import('../views/Intelligent/speechCustom.vue')
      },
    ],
  },
  // 智能数字人模块
  {
    path: '/project',
    name: 'project',
    component: () => import('../views/Intelligent/project.vue'),
    redirect:'/myProject',
    children:[
      {
        path: '/myProject',
        name: 'myProject',
        component: () => import('../views/Intelligent/myProject.vue')
      },
      {
        path: '/cOeProject',
        name: 'cOeProject',
        component: () => import('../views/Intelligent/cOeProject.vue')
      },
      {
        path: '/misAndHisList',
        name: 'misAndHisList',
        component: () => import('../views/Intelligent/misAndHisList.vue')
      },
      {
        path: '/myYl',
        name: 'myYl',
        component: () => import('../views/Intelligent/myYl.vue')
      },
      {
        path: '/knowledge',
        name: 'knowledge',
        component: () => import('../views/Intelligent/knowledge.vue')
      },
      {
        path: '/createYl',
        name: 'createYl',
        component: () => import('../views/Intelligent/createYl.vue')
      },
      {
        path: '/myDigitalHuman',
        name: 'myDigitalHuman',
        component: () => import('../views/Intelligent/myDigitalHuman.vue')
      },
      {
        path: '/myTimbre',
        name: 'myTimbre',
        component: () => import('../views/Intelligent/myTimbre.vue')
      },
    ]
  },
  // 孪生数字人模块
  {
    path: '/twinHuman',
    name: 'twinHuman',
    component: () => import('../views/Twin/mine.vue'),
    redirect:'/myWork',
    children:[
      {
        path: '/myWork',
        name: 'myWork',
        component: () => import('../views/Twin/myWork.vue')
      },
      {
        path: '/myHuman',
        name: 'myHuman',
        component: () => import('../views/Twin/myHuman.vue')
      },
      {
        path: '/myDraft',
        name: 'myDraft',
        component: () => import('../views/Twin/myDraft.vue')
      },
      {
        path: '/mySource',
        name: 'mySource',
        component: () => import('../views/Twin/mySource.vue')
      },
      {
        path: '/opration',
        name: 'opration',
        component: () => import('../views/Twin/opration.vue')
      },
    ]
  },
  
  
]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})
router.beforeEach((to, from, next) => {
  const token = window.localStorage.getItem('token')
  if (token) {
    next()
  } else {
    if (to.path === '/login' || to.path === '/agreement' || to.path === '/') {
      next()
    } else {
      next('/')
    }
  }
})
export default router
